import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { homeFor } from "@/lib/roles";
import { api, errMsg } from "@/lib/api";

export default function ChangePassword() {
  const { user, setToken, logout } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ currentPassword: "", newPassword: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const forced = user?.mustChangePassword;
  const submit = async (e) => {
    e.preventDefault();
    if (f.newPassword !== f.confirm) return setErr("New passwords do not match");
    setBusy(true);
    setErr("");
    try {
      const r = await api.post("/auth/change-password", { currentPassword: f.currentPassword, newPassword: f.newPassword });
      await setToken(r.data.token);
      toast.success("Password updated");
      nav(homeFor(user));
    } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-muted/30">
      <form onSubmit={submit} className="w-full max-w-sm rounded-xl border bg-card p-8 space-y-5 fade-up" data-testid="change-password-form">
        <div className="h-10 w-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center"><KeyRound className="h-5 w-5" /></div>
        <div>
          <h1 className="text-xl font-bold">{forced ? "Set a new password" : "Change password"}</h1>
          <p className="text-sm text-muted-foreground mt-1">{forced ? "Your administrator issued a temporary password. Choose your own to continue." : "Use at least 8 characters."}</p>
        </div>
        <div className="space-y-1.5"><Label>{forced ? "Temporary password" : "Current password"}</Label><Input type="password" required value={f.currentPassword} onChange={set("currentPassword")} data-testid="current-password-input" /></div>
        <div className="space-y-1.5"><Label>New password</Label><Input type="password" required minLength={8} value={f.newPassword} onChange={set("newPassword")} data-testid="new-password-input" /></div>
        <div className="space-y-1.5"><Label>Confirm new password</Label><Input type="password" required value={f.confirm} onChange={set("confirm")} data-testid="confirm-password-input" /></div>
        {err && <div className="text-sm text-destructive" data-testid="change-password-error">{err}</div>}
        <Button type="submit" className="w-full" disabled={busy} data-testid="change-password-submit">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Update password</Button>
        <Button type="button" variant="ghost" className="w-full" onClick={forced ? logout : () => nav(-1)} data-testid="change-password-cancel">{forced ? "Sign out" : "Cancel"}</Button>
      </form>
    </div>
  );
}
